module.exports = __webpack_public_path__ + "static/img/vr6.a7da24e7.png";